import xiaolaba from "@/assets/new/xiaolaba.png";
import { getScrollMarquee } from "@/lobby_common/api/basic_gen.js";
import { getGameGroupBySid } from "@/lobby_common/api/game_gen.js";
import { goJoinEvent } from "@/lobby_common/utils/utils.js";
import { divideAccuracy } from "@/lobby_common/utils/utils.js";

export default {
  name: "my-marquee-left",
  props: {
    sendVal: Array,
  },
  data() {
    return {
      xiaolaba,
      list: [],
      timer: null,
      end: 0,
      currentIndex: 0,
      observedElements: new Map(),
    };
  },
  computed: {
    getIsMobile() {
      return this.$store.getters.getIsMobile;
    },
    isLogin() {
      return this.$store.getters.login;
    },
  },
  async mounted() {
    const target = this.$refs.box;
    const boxWrap = this.$refs.boxWrap;
    let initLeft = 0;

    // if (!this.$store.getters.taken) {
    //   return false;
    // }

    const { code, data } = await getScrollMarquee({});
    // const code = 0
    if (code === 0) {
      this.list = data.list.map((v) => {
        return {
          ...v,
          type: "scroll",
          showPoint: v?.jump?.type !== "Jump_TYPE_ALL",
          content: this.replaceTemplate(v.language?.content),
        };
      });
      this.$nextTick(() => {
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          initLeft++;
          const end = target?.offsetWidth + boxWrap?.offsetWidth;
          if (initLeft >= end) {
            initLeft = 0;
            this.list = this.list.filter((e) => e.type !== "pop");
          }
          target.style = "transform: translateX(-" + initLeft + "px)";
        }, 30);
      })
    }

    this.initObserver();
    this.$Bus.$on("marqueeInsert", this.onInsertData);
  },
  methods: {
    replaceTemplate(text) {
      return text.replace(
        /##\s*(.*?)\s*##/g,
        '<span class="color-light">$1</span>'
      );
    },
    async handleJump(item) {
      if (item.type === "scroll") {
        if (item?.jump?.type === "Jump_TYPE_ALL") {
          return;
        }
        // 通用跳转方法
        goJoinEvent(item?.jump);
      } else if (item.type === "pop") {
        if (item?.marqueePopType === 1) {
          // 跳转游戏
          if (!this.isLogin) {
            this.$isPopShow({ show: false, views: "" });
            this.$Bus.$emit("showLogin");
            return;
          }
          // 获取游戏记录信息
          const detail = await getGameGroupBySid({
            gameGroupSid: item.gameGroupSid,
          });
          if (detail.code === 0) {
            this.$refs.jpDetailDialog.show({
              ...item,
              ...detail.data,
              userName: item.nickname,
              createdAt: item.gameSettleTime,
              multiple: item.rewardMulti,
              betAmount: divideAccuracy(item.allBets, item.accuracy),
              gameRewardAmount: divideAccuracy(item.allDpay, item.accuracy),
              coin_icon: item.coinCodeIcon,
              gamePcIcon: detail.data.appOrPcUrl,
              brandName: detail.data.brandGroupName,
            });
          }
          return;
        }
        if (item?.marqueePopType === 2) {
          // 跳转活动详情
          const path = "/hactivityDetail/";
          this.$router.push({
            path: `${path}${item?.activitySid || ""}`,
          });
          return;
        }
      }
    },
    initObserver() {
      const boxWrap = this.$refs.boxWrap;
      const target = this.$refs.box;

      if (!target || !boxWrap) return;

      if (this.observer) {
        this.observer.disconnect();
      }

      // 监听列表中所有的公告项
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // 记录当前正在显示的项索引
              this.currentIndex = Number(entry.target.getAttribute("index"));
              return;
            }
          });
        },
        { root: boxWrap, threshold: 0 }
      ); // 只有 5% 以上可见才算当前项

      // 监听所有公告项
      this.$nextTick(() => {
        target.children.forEach((item) => this.observer.observe(item));
      });
    },

    // 2️⃣ 插入公告
    onInsertData(newItem) {
      let content = "";
      // 游戏结算
      if (newItem?.marqueePopType === 1) {
        content = `${newItem?.nickname || ""}${this.$t(
          "Datalang.VIPSpin_Spin_in"
        )}${newItem?.gameGroupName || ""}${this.$t("Datalang.home_win")}${
          divideAccuracy(newItem?.settleAmount, newItem.accuracy) || ""
        }${newItem?.coinCode || ""}`;
        // content = formatLang(this.$t('Datalang.home_won_brl'), [newItem?.nickname || '', newItem?.gameGroupName || '', newItem?.amount || '']);
      } else if (newItem?.marqueePopType === 2) {
        // 佣金发放
        content = `${newItem?.nickname || ""}${this.$t(
          "Datalang.VIPSpin_Spin_in"
        )}${newItem?.activityName || ""}${this.$t("Datalang.wallet_Get")}${
          newItem?.amount || ""
        }${newItem?.coinCode || ""}`;
        // content = formatLang(this.$t('Datalang.home_won_brl'), [newItem?.nickname || '', newItem?.activityName || '', newItem?.amount || '']);
      }
      newItem = {
        ...newItem,
        type: "pop",
        showPoint: true,
        _id: window.crypto.randomUUID(),
        content,
      };
      // 在当前显示项的后面插入公告
      // this.list.splice(this.currentIndex + 1, 0, newItem);
      this.list.push(newItem);
      setTimeout(() => {
        this.initObserver();
      }, 200);
    },
  },
  beforeDestroy() {
    this.$Bus.$off("marqueeInsert", this.onInsertData);
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
